import {useRef, type TouchEventHandler} from 'react'
import type {TarjetaCola} from '@/lib/bateria-cola'

const SWIPE_MIN_PX = 60

// El scroll vertical en celular deriva de lado: lo horizontal debe dominar para no confundirlo con
// un swipe.
const SWIPE_DOMINANCIA_HORIZONTAL = 2

type Toque = {x: number; y: number}

/** Equivalente táctil de la tecla `D`: arrastrar la tarjeta a un lado la deja para después. */
export function useSwipeParaDespues(
  actual: TarjetaCola | undefined,
  enTarjetas: boolean,
  dejarParaDespues: (tarjeta: TarjetaCola) => void
): {onTouchStart: TouchEventHandler; onTouchEnd: TouchEventHandler} {
  const inicioTactil = useRef<Toque | null>(null)
  return {
    onTouchStart: (e) => {
      const toque = e.changedTouches[0]
      inicioTactil.current = toque ? {x: toque.clientX, y: toque.clientY} : null
    },
    onTouchEnd: (e) => {
      const inicio = inicioTactil.current
      const fin = e.changedTouches[0]
      inicioTactil.current = null
      if (!inicio || !fin || !actual || !enTarjetas) return
      const dx = Math.abs(fin.clientX - inicio.x)
      const dy = Math.abs(fin.clientY - inicio.y)
      if (dx >= SWIPE_MIN_PX && dx >= dy * SWIPE_DOMINANCIA_HORIZONTAL) dejarParaDespues(actual)
    },
  }
}
